import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ru } from './ru';

/* Single-locale init for now: Russian only. All keys live under one
   `translation` namespace so callers use dotted paths (`t('auth.x')`)
   without an explicit namespace prefix. Adding English later means
   another resources block + an `lng` toggle. */

void i18n.use(initReactI18next).init({
  lng: 'ru',
  fallbackLng: 'ru',
  defaultNS: 'translation',
  resources: {
    ru: { translation: ru },
  },
  interpolation: { escapeValue: false },
  returnNull: false,
});

export { i18n };
